<template>
  <div id="Field_portable_system">
    <div class="font">
      <span class="introSubTitle"><b>便携式遥感影像快速处理系统</b></span>
      <p class="textStyle">
        设计了可扩展式的快速数据处理框架，利用多核CPU+GPU硬件搭建的混合加速环境，研制了便携式遥感影像快速处理系统，从64位计算、数据“不落盘”技术、内存高效管理、多粒度多层次的算法加速模型优化等方面实现了小型化、集成化卫星、无人机影像快速处理。
      </p>
    </div>
  <!-- <br/>   -->
    <img width="100%" src="@/assets/img/scientific/Portable_handle.jpg" />
    <p class="img_figure">地面快速处理系统</p>
  </div>
</template>

<script>
// import myVideo from "../../node_modules/vue-video";

export default {
  data() {
    return {};
  },
};
</script>

<style lang="less">
#Field_portable_system {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #4f4f4f;
  }
}
</style>
